import React from 'react'
import Svg from './Svg'
export const SvgMinus = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M0 9h24v6H0z" />
  </Svg>
))
SvgMinus.isIcon = true
export default SvgMinus
